module.exports = __webpack_public_path__ + "static/media/Food.edf18215.png";